<template>
    <div
        class="most-popular"
        :class="[ props.isActive ? cardData.getClassActive(): '', props.cardData.getClass(), props.isParentallyRestricted ? props.cardData.getClassLock(): '' ]"
    >
        <div class="most-popular__wrapper-image"> 
           <img 
            v-if="imageUrl"
            loading="lazy"
            alt=""
            class="most-popular__image"
            :src="imageUrl">
        </div>
    </div>
</template>

<script setup lang="ts">
    import { type PropType, type Ref, ref } from "vue";
    import type { SlideData } from "../types";

    const props = defineProps({
        cardData: {
            type: Object as PropType<SlideData>,
            required: true
        },
        isParentallyRestricted: {
            type: Boolean,
            required: true,
        },
        isActive: {
            type: Boolean,
            required: true,
        },
    });


    const { $domains} = useNuxtApp();
    const imageUrl: Ref< string | null> = ref("");
    const fetchBackgroundImage = async (): Promise<void> => {
        const cardImage = await $domains.imagesRepository.getOnDemandBackgroundImage(props.cardData.getPlayItem().images);

        if (!cardImage) {
            imageUrl.value = props.cardData.getImage();
        } else {
            imageUrl.value = cardImage;
        }
    };
    const loadData = async () => {
        fetchBackgroundImage();
    };

    loadData();
</script>

<style lang="scss">
    @import url("styles.scss");
</style>